import css from 'styled-jsx/css';

const styles = css.global`#energia-solar-qualidade {
  background: #F0F8F0;
  padding: 56px 0;
  overflow: hidden;
}

#energia-solar-qualidade .qualidade-textos {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

#energia-solar-qualidade .qualidade-titulos {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#energia-solar-qualidade .qualidade-titulos .qualidade-titulo {
  margin: 0;
  color: #222;
  text-align: center;
  font-family: "SantanderHeadline";
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
}

#energia-solar-qualidade .qualidade-titulos .qualidade-subtitulo {
  color: #444;
  text-align: center;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#energia-solar-qualidade .qualidade-itens {
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  margin: 40px auto 24px;
  max-width: 380px;
  padding: 0 16px;
}

#energia-solar-qualidade .qualidade-itens .qualidade-item {
  display: flex;
  gap: 8px;
  align-items: center;
}

#energia-solar-qualidade .qualidade-itens .qualidade-item-texto {
  color: #222;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

#energia-solar-qualidade .qualidade-imagens {
  display: flex;
  flex-direction: column;
  align-items: center;
}

#energia-solar-qualidade .qualidade-imagens img {
  mix-blend-mode: multiply;
}


@media (min-width: 992px) {
  #energia-solar-qualidade {
    padding: 64px 0;
  }

  #energia-solar-qualidade .qualidade-textos {
    gap: 56px;
  }


  #energia-solar-qualidade .qualidade-titulos .qualidade-titulo {
    font-size: 56px;
  }

  #energia-solar-qualidade .qualidade-titulos .qualidade-subtitulo {
    color: #222;
  }

  #energia-solar-qualidade .qualidade-itens {
    flex-direction: row;
    gap: 32px;
    margin: 56px auto 48px;
    max-width: 100%;
  }

  #energia-solar-qualidade .qualidade-imagens {
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
}`;

export default styles;